import { render, staticRenderFns } from "./tab-personalizacao.vue?vue&type=template&id=705241a6&scoped=true&"
import script from "./tab-personalizacao.vue?vue&type=script&lang=js&"
export * from "./tab-personalizacao.vue?vue&type=script&lang=js&"
import style0 from "./tab-personalizacao.vue?vue&type=style&index=0&id=705241a6&scoped=true&lang=css&"
import style1 from "./tab-personalizacao.vue?vue&type=style&index=1&id=705241a6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "705241a6",
  null
  
)

export default component.exports